import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu as MenuIcon, X } from "lucide-react";
import { cafeInfo } from "@/data/menu";

const NAV_LINKS = [
  { label: "Menü", href: "#menu" },
  { label: "Standort", href: "#standort" },
  { label: "Bewertungen", href: "#bewertungen" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (e, href) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        setOpen(false);
      }
    }
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass-nav" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 md:px-10">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-display text-2xl font-extrabold tracking-tight text-brand md:text-3xl"
        >
          {cafeInfo.name}
        </Link>

        <ul className="hidden items-center gap-10 md:flex">
          {NAV_LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                onClick={(e) => handleNavClick(e, l.href)}
                className="link-underline text-sm font-medium text-brand"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          aria-label="Menü öffnen"
          data-testid="nav-mobile-toggle"
          className="md:hidden rounded-full border border-warm p-2"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={20} /> : <MenuIcon size={20} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-warm bg-white px-6 py-6"
        >
          <ul className="flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                  onClick={(e) => handleNavClick(e, l.href)}
                  className="text-lg font-medium text-brand"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}
